export interface ScreenSource {
  id: string;
  name: string;
  thumbnail: string;
}

export function ScreenPickerModal({
  sources,
  onSelect,
  onClose,
  isLoading
}: {
  sources: ScreenSource[];
  onSelect: (id: string) => void;
  onClose: () => void;
  isLoading: boolean;
}) {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-[#1a1a2e] border border-purple-500/30 rounded-2xl w-full max-w-4xl max-h-[80vh] flex flex-col shadow-2xl animate-in fade-in zoom-in duration-200">
        <div className="p-6 border-b border-white/5 flex items-center justify-between shrink-0">
          <div>
            <h2 className="text-white font-bold text-xl">Select Screen or Window</h2>
            <p className="text-gray-400 text-sm">Choose what you want the AI to see</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/5 rounded-lg text-gray-400 hover:text-white transition-colors">
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6 custom-scrollbar">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center h-48 space-y-4">
              <div className="w-10 h-10 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-gray-400 animate-pulse">Scanning displays...</p>
            </div>
          ) : sources.length === 0 ? (
            <div className="text-center py-12 text-gray-500">No sources found.</div>
          ) : (
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
              {sources.map((source) => (
                <button
                  key={source.id}
                  onClick={() => onSelect(source.id)}
                  className="group relative bg-black/40 border border-white/5 hover:border-purple-500/50 rounded-xl overflow-hidden transition-all hover:scale-[1.02] hover:shadow-lg hover:shadow-purple-500/10 text-left flex flex-col h-full"
                >
                  <div className="aspect-video bg-black relative w-full border-b border-white/5">
                    <img src={source.thumbnail} alt={source.name} className="w-full h-full object-contain" />
                  </div>
                  <div className="p-3 bg-[#13131f] flex-1 w-full">
                    <p className="text-white text-sm font-bold truncate w-full" title={source.name}>{source.name}</p>
                    <p className="text-xs text-gray-500 mt-1 truncate">{source.id.split(':')[0]}</p>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
